import React from "react";

export const ACCENT = "#0B1E3F";

export const Field = ({ label, children }) => (
  <label className="block">
    <div className="text-[10px] tracking-[0.15em] uppercase font-bold text-slate-500 mb-1">{label}</div>
    {children}
  </label>
);

export const Input = (props) => (
  <input {...props} className={`w-full border border-slate-300 px-2 py-1.5 text-sm rounded-sm focus:border-[#0B1E3F] focus:ring-1 focus:ring-[#0B1E3F] outline-none ${props.className || ""}`} />
);

export const Select = ({ children, ...props }) => (
  <select {...props} className={`w-full border border-slate-300 px-2 py-1.5 text-sm bg-white rounded-sm focus:border-[#0B1E3F] focus:ring-1 focus:ring-[#0B1E3F] outline-none ${props.className || ""}`}>
    {children}
  </select>
);

export const Card = ({ title, subtitle, children, testid, actions }) => (
  <div className="rounded-sm border border-slate-200 bg-white shadow-sm p-5" data-testid={testid}>
    {(title || actions) && (
      <div className="flex items-start justify-between gap-3 mb-4 pb-3 border-b border-slate-100">
        <div>
          {title && <h3 className="text-[15px] font-semibold tracking-tight text-[#0F172A]">{title}</h3>}
          {subtitle && <p className="text-[12px] text-slate-500 mt-0.5 max-w-2xl">{subtitle}</p>}
        </div>
        {actions}
      </div>
    )}
    {children}
  </div>
);

export const Btn = ({ children, ...props }) => (
  <button {...props}
    className={`bg-[#0B1E3F] hover:bg-[#172E5D] text-white px-4 py-2 text-[12px] font-semibold tracking-wide rounded-sm transition-colors focus:ring-2 focus:ring-[#C8A24B] focus:ring-offset-1 disabled:opacity-50 ${props.className || ""}`}>
    {children}
  </button>
);
